module.exports = __webpack_public_path__ + "annualreview2018/static/pdfs/ukpn-annual-review-2018.a8ca986.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/ukpn-annual-review-2018.pdf
// module id = je7w
// module chunks = 10